"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateAllClasses = updateAllClasses;
exports.asValue = asValue;
exports.parseColorFormat = parseColorFormat;
exports.asColor = asColor;
exports.asLookupValue = asLookupValue;
exports.coerceValue = coerceValue;

var _postcssSelectorParser = _interopRequireDefault(require("postcss-selector-parser"));

var _escapeCommas = _interopRequireDefault(require("./escapeCommas"));

var _withAlphaVariable = require("./withAlphaVariable");

var _dataTypes = require("./dataTypes");

var _negateValue = _interopRequireDefault(require("./negateValue"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function updateAllClasses(selectors1, updateClass) {
  var parser = (0, _postcssSelectorParser).default(function (selectors) {
    selectors.walkClasses(function (sel) {
      var updatedClass = updateClass(sel.value);
      sel.value = updatedClass;

      if (sel.raws && sel.raws.value) {
        sel.raws.value = (0, _escapeCommas).default(sel.raws.value);
      }
    });
  });
  var result = parser.processSync(selectors1);
  return result;
}

function resolveArbitraryValue(modifier, validate) {
  if (!isArbitraryValue(modifier)) {
    return undefined;
  }

  var value = modifier.slice(1, -1);

  if (!validate(value)) {
    return undefined;
  }

  return (0, _dataTypes).normalize(value);
}

function asNegativeValue(modifier) {
  var lookup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var validate = arguments.length > 2 ? arguments[2] : undefined;
  var positiveValue = lookup[modifier];

  if (positiveValue !== undefined) {
    return (0, _negateValue).default(positiveValue);
  }

  if (isArbitraryValue(modifier)) {
    var resolved = resolveArbitraryValue(modifier, validate);

    if (resolved === undefined) {
      return undefined;
    }

    return (0, _negateValue).default(resolved);
  }
}

function asValue(modifier) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$validate = _ref.validate,
      validate = _ref$validate === void 0 ? function () {
    return true;
  } : _ref$validate;

  var ref;
  var value = (ref = options.values) === null || ref === void 0 ? void 0 : ref[modifier];

  if (value !== undefined) {
    return value;
  }

  if (options.supportsNegativeValues && modifier.startsWith("-")) {
    return asNegativeValue(modifier.slice(1), options.values, validate);
  }

  return resolveArbitraryValue(modifier, validate);
}

function isArbitraryValue(input) {
  return input.startsWith("[") && input.endsWith("]");
}

function splitAlpha(modifier) {
  var slashIdx = modifier.lastIndexOf("/");

  if (slashIdx === -1 || slashIdx === modifier.length - 1) {
    return [modifier];
  }

  return [modifier.slice(0, slashIdx), modifier.slice(slashIdx + 1)];
}

function parseColorFormat(value) {
  if (typeof value === "string" && value.includes("<alpha-value>")) {
    var oldValue = value;
    return function (_ref2) {
      var _ref2$opacityValue = _ref2.opacityValue,
          opacityValue = _ref2$opacityValue === void 0 ? 1 : _ref2$opacityValue;
      return oldValue.replace("<alpha-value>", opacityValue);
    };
  }

  return value;
}

function asColor(modifier) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref3$tailwindConfig = _ref3.tailwindConfig,
      tailwindConfig = _ref3$tailwindConfig === void 0 ? {} : _ref3$tailwindConfig;

  var ref;

  if (((ref = options.values) === null || ref === void 0 ? void 0 : ref[modifier]) !== undefined) {
    var ref1;
    return parseColorFormat((ref1 = options.values) === null || ref1 === void 0 ? void 0 : ref1[modifier]);
  }

  var _splitAlpha = splitAlpha(modifier),
      _splitAlpha2 = _slicedToArray(_splitAlpha, 2),
      color = _splitAlpha2[0],
      alpha = _splitAlpha2[1];

  if (alpha !== undefined) {
    var ref2, ref3, ref4;
    var ref5;
    var normalizedColor = (ref5 = (ref2 = options.values) === null || ref2 === void 0 ? void 0 : ref2[color]) !== null && ref5 !== void 0 ? ref5 : isArbitraryValue(color) ? color.slice(1, -1) : undefined;

    if (normalizedColor === undefined) {
      return undefined;
    }

    normalizedColor = parseColorFormat(normalizedColor);

    if (isArbitraryValue(alpha)) {
      return (0, _withAlphaVariable).withAlphaValue(normalizedColor, alpha.slice(1, -1));
    }

    if (((ref3 = tailwindConfig.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.opacity) === null || ref4 === void 0 ? void 0 : ref4[alpha]) === undefined) {
      return undefined;
    }

    return (0, _withAlphaVariable).withAlphaValue(normalizedColor, tailwindConfig.theme.opacity[alpha]);
  }

  return asValue(modifier, options, {
    validate: _dataTypes.color
  });
}

function asLookupValue(modifier) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ref;
  return (ref = options.values) === null || ref === void 0 ? void 0 : ref[modifier];
}

function guess(validate) {
  return function (modifier, options) {
    return asValue(modifier, options, {
      validate: validate
    });
  };
}

var typeMap = {
  any: asValue,
  color: asColor,
  url: guess(_dataTypes.url),
  image: guess(_dataTypes.image),
  length: guess(_dataTypes.length),
  percentage: guess(_dataTypes.percentage),
  position: guess(_dataTypes.position),
  lookup: asLookupValue,
  "generic-name": guess(_dataTypes.genericName),
  "family-name": guess(_dataTypes.familyName),
  number: guess(_dataTypes.number),
  "line-width": guess(_dataTypes.lineWidth),
  "absolute-size": guess(_dataTypes.absoluteSize),
  "relative-size": guess(_dataTypes.relativeSize),
  shadow: guess(_dataTypes.shadow)
};
var supportedTypes = Object.keys(typeMap);

function splitAtFirst(input, delim) {
  var idx = input.indexOf(delim);
  if (idx === -1) return [undefined, input];
  return [input.slice(0, idx), input.slice(idx + 1)];
}

function coerceValue(types, modifier, options, tailwindConfig) {
  if (isArbitraryValue(modifier)) {
    var arbitraryValue = modifier.slice(1, -1);

    var _splitAtFirst = splitAtFirst(arbitraryValue, ":"),
        _splitAtFirst2 = _slicedToArray(_splitAtFirst, 2),
        explicitType = _splitAtFirst2[0],
        value = _splitAtFirst2[1]; // It could be that this resolves to `url(https` which is not a valid
    // identifier. We currently only support "simple" words with dashes or
    // underscores. E.g.: family-name


    if (!/^[\w-_]+$/g.test(explicitType)) {
      value = arbitraryValue;
    } else if (explicitType !== undefined && !supportedTypes.includes(explicitType)) {
      return [];
    }

    if (value.length > 0 && supportedTypes.includes(explicitType)) {
      return [asValue("[".concat(value, "]"), options), explicitType];
    }
  } // Find first matching type


  var _iterator = _createForOfIteratorHelper([].concat(types)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var type = _step.value;
      var result = typeMap[type](modifier, options, {
        tailwindConfig: tailwindConfig
      });
      if (result !== undefined) return [result, type];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return [];
}